
import interactive from "../../Screens_old/../assets/images/interactive.webp";
import experts from "../../Screens_old/../assets/images/experts.webp";
import industry from "../../Screens_old/../assets/images/industry.webp";
import structured_syllabus from "../../Screens_old/../assets/images/structured_syllabus.webp";
import real_world_cryptography_cohort from "../../assets/images/cohorts/real_world_cryptography_cohort.jpg";
import network_security_cohort from "../../assets/images/cohorts/network_security_cohort.jpg";
import web_security_cohort from "../../assets/images/cohorts/web_security_cohort.jpg";


export const stepsToAdoptBodhitree = [
    {
        id: 1,
        image: experts,
        title: "Learn from subject matter experts and award-winning teachers",
        desc: "Engage with top experts who will offer in-depth knowledge and real-world best practices",
        // buttonTitle: "Server Requirement",
    },
    {
        id: 2,
        image: interactive,
        title: "Experience hands-on interactive learning",
        desc: "Every concept reinforced via weekly labs on a novel lab platform that sets up real-world environments",
        // desc: "Each week, hands-on labs on a unique platform will reinforce learning, with a fully set-up environment and auto-grading.",
    },
    {
        id: 3,
        image: industry,
        title: "Industry-based curriculum",
        // desc: "All syllabus has been carefully curated based on discussions with industry experts to equip you with real world practical skills to excel in your career",
        desc: "A carefully curated syllabus with real world practical skills to excel in your career.",
    },
    {
        id: 4,
        image: structured_syllabus,
        title: "Structured syllabus and high quality assessment",
        // desc: "Our online courses follow the same structured approach as our in-person programs, with dedicated TA support for weekly labs and tutorials to ensure your success",
        desc: "Our online courses mirror in-person programs, offering structured learning with TA support and proctored on-campus theory+lab exams",
        // buttonTitle: "Sign Up",
    },
    // {
    //   id: 5,
    //   image: explore_icon,
    //   title: "Earn a Professional Certificate",
    //   desc: " Complete 3 or more courses within a thematic pool to become an expert in a chosen field and improve your job prospects",
    //   buttonTitle: "Sign Up",
    // },
];
export const cohorts = [
    {
        image: real_world_cryptography_cohort,
        title: "Real World Cryptography",
        description: "Build strong foundations in cryptographic principles, algorithms and secure communication.",
    },
    {
        image: network_security_cohort,
        title: "Network Security",
        description: "Explore network security concepts, threats, protocols and practical security techniques.",
    },
    {
        image: web_security_cohort,
        title: "Web Security",
        description: "Develop practical understanding of web vulnerabilities, attacks and defence mechanisms.",
    },
];
